import moment from 'moment';

import { ExamStatusEnum, Session } from 'src/models/Session.model';

import useUiTranslation from 'src/hooks/useUiTranslation';

const useGetExamGetPendingStatusText = () => {
  const { tCommon } = useUiTranslation();

  return (session: Session): string => {
    // Both files have been uploaded
    if (session.leftImageFile && session.rightImageFile) {
      return tCommon(`examFields.examStatusEnum.${ExamStatusEnum.QUEUED}`);
    }

    const progressText =
      session.leftImageFile || session.rightImageFile ? '(1/2)' : '(0/2)';

    // Session was created less than 1 minute ago
    if (moment().diff(session.createdAt, 'seconds') < 60) {
      return (
        tCommon(`examFields.examStatusEnum.${ExamStatusEnum.UPLOADING}`) +
        ` ${progressText}`
      );
    }

    // Upload is incomplete and has exceeded 1 minute
    return (
      tCommon(`examFields.examStatusEnum.${ExamStatusEnum.UPLOAD_FAILED}`) +
      ` ${progressText}`
    );
  };
};

export default useGetExamGetPendingStatusText;
